import { createSelector } from 'reselect';
import { MAILING_LIST_TYPE } from '../constants';

const getMailingLists = email => ({
  lists: email.lists || [],
});

export const getNormalLists = createSelector(getMailingLists, ({ lists }) =>
  lists.filter(link => link.mailing_list.type === MAILING_LIST_TYPE.NORMAL)
);

export const getOpportunityLists = createSelector(getMailingLists, ({ lists }) =>
  lists.filter(link => link.mailing_list.type === MAILING_LIST_TYPE.OPPORTUNITY)
);

export const isLookingForOpportunities = createSelector(getMailingLists, ({ lists }) => {
  const opportunityMailingLists = lists.filter(link => link.mailing_list.type === MAILING_LIST_TYPE.OPPORTUNITY);
  return opportunityMailingLists.some(mailListItem => mailListItem.subscribed === true);
});
